import styled from 'styled-components';
import colors from 'styles/colors';
import { fontWeight } from 'styles/common';
import { InputContainer as BaseInputContainer } from 'styles/form';
import { TITLE_HEIGHT, TITLE_MARGIN } from 'styles/settings';

export const Section = styled.div`
  border-bottom: 1px solid ${colors.gray80};
  padding-bottom: 35px;
  margin-bottom: 20px;

  &:last-child {
    border: 0;
  }
`;

export const SubSection = styled.p`
  font-size: 12px;
  line-height: 17px;
  margin-top: 12px;
  margin-bottom: 16px;
  max-width: 450px;
`;

export const InputContainer = styled(BaseInputContainer)`
  margin-top: 1em;
  width: 450px;
`;

export const DepenentInputContainer = styled(InputContainer)`
  justify-content: flex-start;
`;

export const IconContainer = styled.div`
  padding-bottom: 6px;
`;

export const InputIndicator = styled.div``;

export const DropdownContainer = styled.div`
  width: 50%;
  max-width: 450px;
  margin: 20px 0;
`;

export const GeofenceTag = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: fit-content;
  height: 30px;
  padding: 0 13px;
  margin: 10px 0;
  background-color: ${colors.filterBackground};
  color: ${colors.primary};
  font-size: 12px;
  line-height: 17px;
  font-weight: ${fontWeight.regular};
`;

export const CloseIcon = styled.i`
  cursor: pointer;
  margin-left: 25px;
  font-variant: unicase !important;
  font-weight: ${fontWeight.semibold} !important;
`;

export const OutsideLink = styled.a`
  font-weight: ${fontWeight.semibold};
`;

export const Divider = styled.div`
  width: 100%;
  background-color: ${colors.tableBorder};
  height: 1px;
  border-radius: 4px;
  margin: auto;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Title = styled.h1`
  display: flex;
  margin: ${TITLE_MARGIN} 0px !important;
  padding: 0 17px;
  color: ${colors.primary};
  font-size: 22px;
  line-height: ${TITLE_HEIGHT};
  font-weight: ${fontWeight.semibold};
  height: ${TITLE_HEIGHT};
  white-space: nowrap;
  width: 180px;
`;

export const SettingsPageView = styled.div`
  display: flex;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DealershipNameContainer = styled.div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: ${fontWeight.semibold};
  width: 100%;
  max-width: 1024px;
  padding: 0 16px;
`;
